import { ApplicationState } from '../../';
import { HomeConfigurationState } from './HomeConfigurationState';

export interface HomeExtensionApplicationState {
  homeConfigurationReducer: HomeConfigurationState;
  applicationStateReducer: ApplicationState;
}
